export default "__VITE_ASSET__DnuElfP$__"